import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css'
// Import local font CSS so bundler includes the fonts in the build
import './lib/fonts/css/satoshi.css';
import { AuthProvider } from "react-oidc-context";
import {
  COGNITO_AUTHORITY,
  COGNITO_CLIENT_ID,
  COGNITO_REDIRECT_URI
} from './config/configCognito';
const { REACT_APP_BASE_WEB_URL } = process.env;

// Ensure the root container exists before passing it to createRoot to satisfy
// TypeScript's non-null requirements and provide a clear error if missing.
const container = document.getElementById('root');
if (!container) {
  throw new Error("Root element with id 'root' not found. Make sure there's an element with id='root' in your HTML.");
}

const cognitoAuthConfig = {
  authority: COGNITO_AUTHORITY,
  client_id: COGNITO_CLIENT_ID,
  redirect_uri: COGNITO_REDIRECT_URI,
  post_logout_redirect_uri: `${REACT_APP_BASE_WEB_URL}/login`,
  response_type: "code",
  scope: "email openid phone",
};

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}
    onSigninCallback={() => {
      window.history.replaceState({}, document.title, window.location.pathname);
    }}
    >
      <App />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
